let init = false;
let firstScrollToTop = false;

class IframeWidget {
    static initializeForwardToStartScroll() {
        (() => {
            const PARENT_ORIGIN = "*"; // docelowo ustaw konkretny origin

            let sx = 0, sy = 0;
            let decided = false;
            let scrollingY = false;
            const TH = 10; // px

            window.addEventListener("pointerdown", (e) => {
                if (e.pointerType !== "touch") return;
                sx = e.clientX;
                sy = e.clientY;
                decided = false;
                scrollingY = false;
            }, {passive: true});

            window.addEventListener("pointermove", (e) => {
                if (e.pointerType !== "touch" || decided) return;

                const dx = Math.abs(e.clientX - sx);
                const dy = Math.abs(e.clientY - sy);

                // pionowy zamiar scrolla
                if (dy > TH && dy > dx) {
                    decided = true;
                    scrollingY = true;
                    window.parent.postMessage({type: "IFRAME_SCROLL_START"}, PARENT_ORIGIN);
                    return;
                }

                // poziomy gest -> nic nie rób, iframe może obsłużyć poziomy scroll
                if (dx > TH && dx > dy) {
                    decided = true;
                    scrollingY = false;
                }
            }, {passive: true});

            function end() {
                if (scrollingY) {
                    window.parent.postMessage({type: "IFRAME_SCROLL_END"}, PARENT_ORIGIN);
                }
                decided = false;
                scrollingY = false;
            }

            window.addEventListener("pointerup", (e) => {
                if (e.pointerType !== "touch") return;
                end();
            }, {passive: true});

            window.addEventListener("pointercancel", (e) => {
                if (e.pointerType !== "touch") return;
                end();
            }, {passive: true});
        })();

    }

    static initialize() {
        this.initializeForwardToStartScroll();

        let parentHeight = undefined as any;
        let top = undefined as any | undefined;
        // Cache elements for fixFixedElements
        let cachedFixedBottom: HTMLCollectionOf<Element> | null = null;
        let cachedStickyFixed: HTMLCollectionOf<Element> | null = null;
        let cachedStickyTop: HTMLCollectionOf<Element> | null = null;
        let cachedPromoTopBanner: HTMLElement | null = null;
        let cachedModals: HTMLCollectionOf<Element> | null = null;
        let cachedFullHeight: HTMLCollectionOf<Element> | null = null;

        function updateCachedElements() {
            cachedFixedBottom = document.getElementsByClassName("fixed-bottom");
            cachedStickyFixed = document.getElementsByClassName("sticky-fixed");
            cachedStickyTop = document.getElementsByClassName("sticky-top");
            cachedPromoTopBanner = document.getElementsByClassName("promo-top-banner")[0] as HTMLElement;
            cachedModals = document.getElementsByClassName("modal");
            cachedFullHeight = document.getElementsByClassName("fixed-height-100");
        }

        function onElementHeightChange(elm: any, callback: any) {
            var lastHeight = elm.clientHeight, newHeight;
            updateCachedElements();
            (function run() {
                newHeight = elm.clientHeight;
                if (lastHeight != newHeight) {
                    callback(newHeight)
                }
                lastHeight = newHeight

                if (elm.onElementHeightChangeTimer)
                    clearTimeout(elm.onElementHeightChangeTimer)

                elm.onElementHeightChangeTimer = setTimeout(run, 200)
            })()
        }

        function fixFixedElements(top: any, bottom: any, parentHeight: any) {
            if (!cachedFixedBottom) updateCachedElements();

            if (top < 0) {
                top = 0;
            }

            let fixedBottomBottom = bottom - parentHeight;
            if (fixedBottomBottom < 15) {
                fixedBottomBottom = 15;
            }

            Array.from(cachedFixedBottom!).forEach((el) => {
                (el as any).style.transform = `translate3d(0, ${-fixedBottomBottom}px, 0)`;
            });

            const promoTopBannerHeight = cachedPromoTopBanner ? cachedPromoTopBanner.offsetHeight : 0;

            Array.from(cachedStickyFixed!).forEach((el) => {
                (el as HTMLElement).style.transform = `translate3d(0, ${top}px, 0)`;
            });

            var topStickyTop = top - promoTopBannerHeight;
            if (topStickyTop < 0) topStickyTop = 0;
            Array.from(cachedStickyTop!).forEach((el) => {
                (el as HTMLElement).style.transform = `translate3d(0, ${topStickyTop}px, 0)`;
            });

            Array.from(cachedModals!).forEach((el) => {
                (el as any).style.top = top + "px";
                let modalDialogs = el.getElementsByClassName("modal-dialog");
                Array.from(modalDialogs).forEach((el1) => {
                    (el1 as any).style.height = parentHeight + "px";
                    const modalContentElement = el1.querySelector(".modal-content");
                    if (modalContentElement) {
                        (modalContentElement as HTMLDivElement).style.maxHeight = `calc(${window.innerHeight}px - ${top}px)`;
                    }
                });
            });

            if (parentHeight > 0) {
                const iframeRect = window.frameElement?.getBoundingClientRect()

                Array.from(cachedFullHeight!).forEach((el) => {
                    const iframeRectTop = iframeRect?.top ?? 0;
                    (el as any).style.height = parentHeight
                        - (parentHeight > bottom ? parentHeight - bottom : 0)
                        - (iframeRectTop > 0 ? iframeRectTop : 0)
                        + "px";
                });
            }
        }

        if (window.top != window.self) {
            if (!init) {
                init = true;
                // window.document.body.classList.add("widget");
                onElementHeightChange(document.body, function (h: any) {
                    updateCachedElements()
                    let message = {type: 'HEIGHT_CHANGED', height: h};
                    window.parent.postMessage(message, "*");
                });
            }
        }
        window.addEventListener("message", function (data) {
            if (data.data === undefined) {
                return;
            }
            switch (data.data.type) {
                case "ENABLE_FULLSCREEN_OFFSET":
                    var widgetElement = document.getElementsByClassName("widget");
                    let iframeOffsetTop = data.data.iframeOffsetTop;

                    Array.from(widgetElement).forEach((el) => {
                        (el as any).style.top = iframeOffsetTop + "px";
                    });
                    let stickyFixedTop = iframeOffsetTop < 0 ? 0 : iframeOffsetTop;
                    var stickyFixed = document.getElementsByClassName("sticky-fixed");
                    const stickyTopElements = document.getElementsByClassName("sticky-top") as HTMLCollectionOf<HTMLElement>;

                    Array.from(stickyFixed).forEach((el) => {
                        (el as HTMLElement).style.transform = `translate3d(0, ${stickyFixedTop}px, 0)`;
                    });

                    Array.from(stickyTopElements).forEach((el) => {
                        (el as HTMLElement).style.transform = `translate3d(0, ${0}px, 0)`;
                    });
                    break;
                case "DISABLE_FULLSCREEN_OFFSET":
                    window.dispatchEvent(new Event('scroll', {detail: top} as any));
                    window.dispatchEvent(new CustomEvent('scroll-iframe', {
                        detail: {
                            top,
                            parentOffset: data.data?.iframeParentOffsetTop ?? 0
                        }
                    }));
                    top = data.data.iframeOffsetTop * -1;
                    var bottom = data.data.iframeOffsetBottom;
                    parentHeight = data.data.iframeParentHeight;
                    fixFixedElements(top, bottom, parentHeight);
                    var widgetElement = document.getElementsByClassName("widget");
                    Array.from(widgetElement).forEach((el) => {
                        (el as any).style.top = "";
                    });
                    break;
                case "PARENT_SCROLL":
                    window.dispatchEvent(new Event('scroll', {detail: top} as any));
                    window.dispatchEvent(new CustomEvent('scroll-iframe', {
                        detail: {
                            top,
                            parentOffset: data.data?.iframeParentOffsetTop ?? 0
                        }
                    }));
                    top = data.data.iframeOffsetTop * -1;
                    var bottom = data.data.iframeOffsetBottom;
                    parentHeight = data.data.iframeParentHeight;
                    fixFixedElements(top, bottom, parentHeight);
                    break;
            }
        }, false);
    }

    static isInit() {
        return init;
    }

    static scrollToTop() {
        if (init) {
            let message = {type: 'HEIGHT_CHANGED', height: document.body.clientHeight, scroll_to_top: firstScrollToTop};
            window.parent.postMessage(message, "*");
            firstScrollToTop = true;
        }
    }

    static scrollTo(value: any) {
        if (init) {
            let message = {type: 'SCROLL_PARENT_TO_IFRAME_OFFSET', offset: value};
            window.parent.postMessage(message, "*");
        }
    }

    static openModal() {
        if (init) {
            let message = {type: 'SIZE_STRETCH'};
            window.parent.postMessage(message, "*");
        }
    }

    static closeModal() {
        if (init) {
            let message = {type: 'SIZE_DEFAULT'};
            window.parent.postMessage(message, "*");
        }
    }

    static onHide(onHide?: any) {
        if (onHide) onHide();
        IframeWidget.closeModal();
    }

    static onShow(onShow?: any) {
        if (onShow) onShow();
        IframeWidget.openModal();
    }
}

export default IframeWidget;
